import { render, staticRenderFns } from "./MatchdayTakeoverV2.vue?vue&type=template&id=39b9e7c0&scoped=true"
import script from "./MatchdayTakeoverV2.vue?vue&type=script&lang=js"
export * from "./MatchdayTakeoverV2.vue?vue&type=script&lang=js"
import style0 from "./MatchdayTakeoverV2.vue?vue&type=style&index=0&id=39b9e7c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b9e7c0",
  null
  
)

export default component.exports